import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, watch } from 'vue'
    import { useOrganizationUnitId, useRouter } from '@common/composables'
    import { useManageBrandingPage } from '@Organizations/OrganizationUnits/pages-core'
    import FileUploader from '@Blobs/Components/FileUploader.vue'
    import axios from 'axios'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ManageBrandingPage',
  setup(__props) {

    const tid = useOrganizationUnitId()
    const logoFile = ref<File | null>(null)
    const logoBlobId = ref<string | null>(null)

    const {
        useBrandingQuery,
        useApplyBrandingCommand,
        useResetBrandingCommand
    } = useManageBrandingPage()

    const { modelBrandingQueryV1, runBrandingQueryV1 } = useBrandingQuery(tid)

    const organizationId = computed(() => modelBrandingQueryV1.value?.Id)
    const logoUrl = computed(() => logoFile.value ? URL.createObjectURL(logoFile.value) : modelBrandingQueryV1.value?.LogoUrl)

    const { invokeApplyBrandingCommandV1 } = useApplyBrandingCommand(organizationId, logoBlobId)
    const { invokeResetBrandingCommandV1 } = useResetBrandingCommand(organizationId)

    onMounted(() => {
        document.title = 'Manage branding'
        runBrandingQueryV1()
    })

    watch(modelBrandingQueryV1, () => logoBlobId.value = modelBrandingQueryV1.value?.LogoBlobId)

    function handleLogoUploaded(blobId: string) {
        logoBlobId.value = blobId
        invokeApplyBrandingCommandV1()        
    }

    async function handleRemoveLogo() {
        if (confirm('Do you really want to remove logo?')) {
            try {
                await axios.delete('/blobs/v2/delete/' + (logoBlobId.value || ''))
            } finally {
                invokeResetBrandingCommandV1()
                runBrandingQueryV1()
                logoFile.value = null
            }
        }
    }

return { __sfc: true,tid, logoFile, logoBlobId, useBrandingQuery, useApplyBrandingCommand, useResetBrandingCommand, modelBrandingQueryV1, runBrandingQueryV1, organizationId, logoUrl, invokeApplyBrandingCommandV1, invokeResetBrandingCommandV1, handleLogoUploaded, handleRemoveLogo, FileUploader }
}

})